<template>
  <basic-container>
    <avue-crud :option="option"
              v-if="showAvueCrudFlag"
               :table-loading="loading"
               :data="data"
               :page="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @on-load="onLoad"
               @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-plus"
                   v-if="permission.deviceinspectplan_add"
                   @click="handleAdd"
        >
          新增
        </el-button>
        <!-- <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   plain
                   v-if="permission.deviceinspectplan_delete"
                   @click="handleDelete">删 除
        </el-button> -->
      </template>
      
      <template slot="menu" slot-scope="scope">
        <el-button 
                  type="text"
                   size="mini"
                   icon="el-icon-view"
                   @click="handleViewInspectPlan(scope.row)"
        >查看</el-button> 
        <el-button 
                  type="text"
                   size="mini"
                   icon="el-icon-edit"
                   @click="handleEditInspectPlan(scope.row)"
        >编辑</el-button> 
        <el-button 
                  type="text"
                   size="mini"
                   icon="el-icon-delete"
                   @click="rowDel(scope.row)"
        >删除</el-button>
      </template>
      <template slot="inspectCycleType" slot-scope="scope">
        <el-tag>{{getInspectCycleType(scope.row.inspectCycleType)}}</el-tag>
      </template>
      <template slot="projectId" slot-scope="scope">
        {{getProjectName(scope.row.projectId)}}
      </template>
      
      <template slot="projectIdSearch" slot-scope="scope">
        <div>
          
          
          <el-select 
              v-model="form.projectId"
              @change="handleDeviceChange"
            >
              <el-option
                  v-for="(item,index) in projectList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
              >

              </el-option>
            </el-select>
        </div>
      </template>
      <template slot="inspectCycleTypeSearch" slot-scope="scope">
        <div>
              <!-- @change="handleDeviceChange" -->
          <el-select 
              v-model="query.inspectCycleType"
            >
              <el-option
                  v-for="(item,index) in inspectCycleTypeList"
                  :key="index"
                  :label="item.dictValue"
                  :value="item.dictKey"
              >

              </el-option>
            </el-select>
        </div>
      </template>
      <template slot="nameSearch" slot-scope="scope">
        <div>
          <el-input v-model="query.name" placeholder="请输入计划名称"></el-input>
        </div>
      </template>
      <template slot="deviceIdSearch" slot-scope="scope">
        
        <div>
          
              <!-- @change="handleDeviceChange" -->
          <el-select 
              v-model="query.deviceId"
            >
              <el-option
                  v-for="(item,index) in deviceList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
              >

              </el-option>
            </el-select>
        </div>
      </template>
    </avue-crud>
    
    <el-dialog
        title="新增"
        :visible.sync="dialogPlanCreateBoxVisible"
        append-to-body
        fullscreen
    >
      <device-inspect-plan-add v-if="dialogPlanCreateBoxVisible" @closeAddForm="handelCloseAddForm"/>
    </el-dialog>
    
    
    <el-dialog
        title="编辑"
        :visible.sync="dialogPlanEditBoxVisible"
        append-to-body
        fullscreen
    >
      <device-inspect-plan-edit v-if="dialogPlanEditBoxVisible" :editFormData="editFormData" @closeEditForm="handelCloseEditForm"/>
    </el-dialog>
    <el-dialog
        title="查看"
        :visible.sync="dialogPlanViewBoxVisible"
        append-to-body
    >
      <device-inspect-plan-view v-if="dialogPlanViewBoxVisible" :editFormData="editFormData" @closeEditForm="handelCloseEditForm"/>
    </el-dialog>
  </basic-container>
</template>

<script>
  import {add, getDetail, getList, remove, update, getDeviceList, getInspectCycleTypeDicData} from "@/api/crmedical/device/deviceinspectplan";
  import {mapGetters} from "vuex";
  // import selectTime from "./select-time";
  import deviceInspectPlanAdd from './device-inspect-plan-add'
  import deviceInspectPlanEdit from './device-inspect-plan-edit'
  import deviceInspectPlanView from './device-inspect-plan-view'
  import {getProjectList} from "@/api/crmedical/group/group";
  export default {
  components: {
    // 'select-time': selectTime,
    'device-inspect-plan-add': deviceInspectPlanAdd,
    'device-inspect-plan-edit': deviceInspectPlanEdit,
    'device-inspect-plan-view': deviceInspectPlanView
  },
    data() {
      return {
        showAvueCrudFlag:false,
        // inspectForm:{},
        deviceList:[],
        // selectedTime:[],
        
        //   inspectCycleType:1,
        // addInspectPlanForm:{
        //   inspectCycleType:1,
        //   detailDate:[],
        // },
        // checklist_:[],
        // checklist:[],
        // dialogInspectLineCreateBoxVisible:false,
        // inspectLineList:[],
        projectList:[],
        inspectCycleTypeList:[],
        dialogPlanEditBoxVisible:false,
        dialogPlanViewBoxVisible:false,
        editFormData:'',
        radio:1,
        dialogPlanCreateBoxVisible:false,
        form: {},
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        selectionList: [],
        option: {
          height: 'auto',
          // calcHeight: 350,
//           projectId	string	
// 非必须
// 项目id	
// name	string	
// 非必须
// 计划名称	
// planBeginTime	string	
// 非必须
// 计划开始时间	
// planEndTime	string	
// 非必须
// 计划结束时间	
// inspectCycleType	number	
// 非必须
// 周期类型	
// timeQuantum	string	
// 非必须
// 具体时间段	
// deviceNames	string	
// 非必须
// 计划巡检设备
          tip: false,
          border: true,
          index: true,
          selection: true,
          addBtn:false,
          editBtn:false,
          delBtn:false,
          viewBtn:false,
          columnBtn: false,
          column: [
            {
              label:'项目名称',
              prop:'projectId',
              slot:true,
              search:true,
              searchslot:true
              // hide:true
            },
            {
              label:'计划名称',
              prop:'name',
              search:true,
              searchslot:true
            },
            {
              label:'计划开始时间',
              prop:'planBeginTime'
            },
            {
              label:'计划结束时间',
              prop:'planEndTime'
            },
            {
              label:'周期类型',
              prop:'inspectCycleType',
              slot:true,
              search:true,
              searchslot:true
            },
            {
              label:'具体时间段',
              prop:'timeQuantum'
            },
            {
              label:'计划巡检设备',
              prop:'deviceNames'
            },
            // deviceIds
            
            {
              label:'设备名称',
              prop:'deviceId',
              hide:true,
              search:true,
              searchslot:true,
              // display:none,
            },
            
          ]
        },
        data: []
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.deviceinspectplan_add, false),
          viewBtn: this.vaildData(this.permission.deviceinspectplan_view, false),
          delBtn: this.vaildData(this.permission.deviceinspectplan_delete, false),
          editBtn: this.vaildData(this.permission.deviceinspectplan_edit, false)
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    created(){
      getProjectList().then((res)=>{
          console.log(res);
          this.projectList = res.data;
          this.form.projectId = res.data[0].id;
          this.query.projectId = res.data[0].id;
          
          getDeviceList({projectId:res.data[0].id}).then((res)=>{
            console.log(res);
            this.deviceList = res.data;
          });
          this.onLoad();
      });
      getInspectCycleTypeDicData().then((res)=>{
          console.log(res);
          this.inspectCycleTypeList = res.data;
          // res.data.forEach((ele,index)=>{
          //   if(ele.dic){

          //   }
          // });
        })
    },
    methods: {
      handleDeleteInspectPlan(row){

      },
      handleDeviceChange(val){
        getDeviceList({projectId:val}).then((res)=>{
          console.log(res);
          this.deviceList = res.data;
        });
      },
      getInspectCycleType(type){
        let dictName = '';
        this.inspectCycleTypeList.forEach((ele)=>{
          if(ele.dictKey==type){
            dictName = ele.dictValue;
          }
        })
        // console.log(dictName);
        return dictName;
      },
      getProjectName(id){
        let dictName = '';
        this.projectList.forEach((ele)=>{
          if(ele.id==id){
            dictName = ele.name;
          }
        })
        // console.log(dictName);
        return dictName;
      },
      handleEditInspectPlan(row){
        console.log(row);
        this.editFormData = row;
        this.dialogPlanEditBoxVisible = true;
      },
      handleViewInspectPlan(row){
        console.log(row);
        this.editFormData = row;
        this.dialogPlanViewBoxVisible = true;
      },
      handelCloseAddForm(){
        this.onLoad();
        this.dialogPlanCreateBoxVisible = false;
      },
      handelCloseViewForm(){
        this.onLoad();
        this.dialogPlanViewBoxVisible = false;
      },
      handelCloseEditForm(){
        this.onLoad();
        this.dialogPlanEditBoxVisible = false;
      },
      rowSave(row, loading, done) {
        add(row).then(() => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        }, error => {
          done();
          console.log(error);
        });
      },
      rowUpdate(row, index, loading, done) {
        update(row).then(() => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        }, error => {
          done();
          console.log(error);
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleAdd(){
        // getDeviceList().then((res)=>{
        //   console.log(res);
        //   this.deviceList = res.data;
        // });
        this.dialogPlanCreateBoxVisible = true;
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        if (["edit", "view"].includes(type)) {
          getDetail({id: this.form.id}).then(({data}) => {
            this.form = data;
          });
        }
        done();
      },
      searchReset() {
        // this.query = {projectId:this.projectList[0].id};
        this.query = {projectId:this.form.projectId};
        console.log();
      setTimeout(()=>{
        this.form = Object.assign({}, this.form, {
          areaName: '',
          areaId: '',
        });
      })
        this.onLoad();
      },
      searchChange(params,done) {
        console.log("params===>",params);
        // this.query = params;
        this.query.projectId = this.form.projectId;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        this.showAvueCrudFlag = true;
        getList(
          Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
        ).then(({data}) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          setTimeout(()=>{
            this.selectionClear();
          });
        });
      }
    }
  };
</script>

<style>
</style>
